import { GetResourceFunction } from "hooks/useResource";

export const formatArrayStrings = (arr: string[], getResource: GetResourceFunction) => {
  if (arr.length <= 1) {
    return arr.join("");
  }
  return `${arr.slice(0, -1).join(", ")} ${getResource("term.and")} ${arr[arr.length - 1]}`;
};
